<template>
  <div>
    <div>
      <!-- 出入金流水 -->
      <div id="flow">
        <div class="headerWrap">
          <div class="rightText">
            <div class="selectText">类型</div>
            <el-select v-model="typeCode" popper-class="selStyle" placeholder="请选择">
              <el-option label="全部" value="全部" />
              <el-option label="出金" value="102" />
              <el-option label="入金" value="101" />
              <el-option label="出金错误回滚资金" value="107" />
            </el-select>
            <el-button
              type="danger"
              @click="param_queryMyIntegralDetail"
            ><span style="color:#fff">查询</span></el-button>
            <!-- <el-button type="success" @click="resetData">重置</el-button> -->
          </div>
        </div>
        <div class="tableWrap">
          <el-table :data="tableData" border style="width: 100%">
            <template slot="empty">
              <div class="no-datas1">
                <div
                  class="no-data-img"
                  style="margin: 100px auto 0px; width: 120px; height: 200px;"
                >
                  <img
                    src="../../../assets/images/no_data.png"
                    alt=""
                    style="width: 100%;"
                  >
                </div>
              </div>
            </template>
            <el-table-column align="center" prop="flowId" label="记录流水">
            </el-table-column>
            <el-table-column align="center" prop="bizName" label="类型">
            </el-table-column>
            <el-table-column align="center" prop="marketName" label="转账系统">
            </el-table-column>
            <el-table-column align="center" prop="amount" label="发生额">
            </el-table-column>
            <el-table-column align="center" prop="balance" label="余额">
            </el-table-column>
            <!-- 转账银行 就是签约银行 -->
            <el-table-column align="center" prop="bankName" label="转账银行">
            </el-table-column>
            <el-table-column prop="occurTime" label="时间" width="180">
              <template slot-scope="scope">
                {{ scope.row.occurTime | dateFormate }}
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
        popper-class='_popStyle'
            :current-page="pageData.currentPage"
            :page-sizes="pageData.pageSizes"
            :page-size="pageData.pageSize"
            layout="total, sizes, prev, pager, next"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*global http protocol*/
export default {
  data() {
    return {
      typeCode: '全部',
      tableData: [],
      pageData: {
        total: 0,
        pageSizes: [5, 10, 20],
        pageSize: 10,
        currentPage: 1
      }
    }
  },
  mounted() {
    this.param_queryMyIntegralDetail()
  },
  methods: {
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.param_queryMyIntegralDetail()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.param_queryMyIntegralDetail()
    },
    // 查询出入金流水
    param_queryMyIntegralDetail() {
      protocol.param_queryFirmBankAccountInoutFundsFlowFront.param.bizCode = this.typeCode == '全部' ? null : this.typeCode
      protocol.param_queryFirmBankAccountInoutFundsFlowFront.param.page = this.pageData.currentPage - 1
      protocol.param_queryFirmBankAccountInoutFundsFlowFront.param.size = this.pageData.pageSize
      http.postFrontChange(protocol.param_queryFirmBankAccountInoutFundsFlowFront, 0).then(response => {
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.pageData.total = response.data.value.totalElements
            const arr = response.data.value.content
            this.tableData = arr
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#flow {
  .headerWrap {
    display: flex;
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    margin-bottom: 13px;
    margin-top: 13px;
    .leftText {
      font-size: 20px;
      font-weight: 500;
      color: #ffffff;
    }
    .rightText {
      display: flex;
      font-size: 16px;
      color: rgba(255, 255, 255, 0.6);
      .selectText {
        padding-right: 10px;
        padding-left: 10px;
        font-size: 16px;
        color: rgba(255, 255, 255, 0.6);
      }
      /deep/ .el-input__inner {
        height: 34px;
        line-height: 34px;
        background-color: transparent;
        border: 1px solid rgba(220, 223, 230, 0.3);
      }
      /deep/ .el-date-editor .el-range-input {
        line-height: 34px;
        background-color: transparent;
      }
      .el-button {
        height: 34px;
        margin: 0 10px;
        padding: 0 25px;
        margin-top: 4px;
      }
    }
  }
  .el-table {
    background-color: #141625;
  }
  /deep/ .el-table__body-wrapper {
    min-height: calc(100vh - 320px);
  }
  /deep/ .el-table__empty-text {
    line-height: calc(100vh - 330px);
  }
}
</style>
<style lang='scss'>
.selStyle {
  width: 130px !important;
  .el-select-dropdown__item.selected{
    text-align: left !important;
  }
  .el-scrollbar__wrap{
    margin-right: -8px !important;
    margin-bottom: -8px !important;
  }
}
</style>
